/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Delete_Success_TitleInputs */

const es_user_profile_api_keys_toasts_delete_success_title = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave API eliminada`)
};

const en_user_profile_api_keys_toasts_delete_success_title = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key deleted`)
};

/**
* | output |
* | --- |
* | "API key deleted" |
*
* @param {User_Profile_Api_Keys_Toasts_Delete_Success_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_delete_success_title = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Delete_Success_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Delete_Success_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_delete_success_title(inputs)
	return en_user_profile_api_keys_toasts_delete_success_title(inputs)
});
export { user_profile_api_keys_toasts_delete_success_title as "user.profile.api_keys.toasts.delete.success_title" }